import styled from "styled-components"

import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"
import { Pagination } from 'ggx-componentlibrary/components/table/pagination/pagination.component'
import { PaginationText } from "ggx-componentlibrary/components/table/pagination/pagination.component.styles"
import Table from 'ggx-src/users-and-branches/users-tab/table/table.component'
import { COLOR } from "ggx-componentlibrary/design/color/color.constants"

const StyledPagination = styled(Pagination)`
  margin-top: 0;
  flex-grow: 1;
  ${PaginationText} {
    margin: 0;
  }
  ${PaginationText} ~ & {
    margin-left: ${SPACING.S};
  }
`

const Footer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 24px;
`

const StyledTable = styled(Table)`
  tr td {
    cursor: pointer;
  }
  tr:hover td {
    background: ${COLOR.GREY_LIGHT};
  }
`

export { Footer, StyledPagination, StyledTable }
